import React from "react";
import dayjs from "dayjs";
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import "ag-grid-community/styles/ag-theme-quartz.css";
import "ag-grid-community/styles/ag-grid.css";

import { useState, useMemo, useEffect, useRef } from "react";
import { FiSearch, FiFilter, FiDownload } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import CustomHeader from "../../Utility/CustomHeader";
import AllAppointmentList from "./AllAppointmentList";
import AppointmentFilterPopover from "../Appointments/AppointmentFilter";
ModuleRegistry.registerModules([AllCommunityModule]);

function HistoryAppointmentList({ data = [], loading }) {
  const [searchTerm, setSearchTerm] = useState("");


  const navigate = useNavigate();

  const completedData = useMemo(() =>
    data.filter(d => d.status === "Completed"), [data]);



  return (
    <>
     <AllAppointmentList data={completedData}  loading={loading} />
    </>
  );
}

export default    HistoryAppointmentList;
